import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfigApi } from "../../config-api";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiCallingService } from "../../services/api-calling.service";
import { Globals } from "../../common/global";
import { ToastrService } from "ngx-toastr";
import { is } from "date-fns/locale";

@Component({
  selector: "app-manage-spot-details",
  templateUrl: "./manage-spot-details.component.html",
  styleUrls: ["./manage-spot-details.component.css"],
})
export class ManageSpotDetailsComponent implements OnInit {
  @ViewChild("refundModal") refundModal: any;
  @ViewChild("cancelRequestModal") cancelRequestModal: any;
  isCancelLoading: boolean = false;
  bookingId: string = "";
  isLoading: boolean = false;
  booking: any;
  detail: any = {
    is_refund_full_amount: null,
    amountTotal: null,
  };
  cancelRequestId: string = "";
  refundId: string = "";

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private apiCallingService: ApiCallingService,
    public Globals: Globals,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) {
    this.bookingId = this.route.snapshot.paramMap.get("id") || "";
  }

  ngOnInit(): void {
    this.getDetails();
  }

  openRefundModal(spotPurchaseId: string) {
    this.modalService.open(this.refundModal, {
      size: "md",
      backdrop: "static",
    });
    this.refundId = spotPurchaseId;
  }

  getDetails(): void {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.SPOT_BOOKING.PURCHASE_BOOKING_DETAILS +
          "/" +
          this.bookingId
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.booking = res.data;
          } else {
            console.error(res.msg);
          }
        },
        (err) => {
          this.toastr.error(err.error.msg, "Error");
        }
      );
  }
  submitRefund(form: any) {
    if (this.detail.is_refund_full_amount === false) {
      if (!this.detail.amountTotal) {
        return;
      }
    }

    this.isLoading = true;

    const payload: any = {
      spotPurchaseSlotId: this.refundId,
      is_refund_full_amount: this.detail.is_refund_full_amount,
    };
    if (this.detail.is_refund_full_amount === false) {
      payload.refund_amount = this.detail.amountTotal;
    }

    this.apiCallingService
      .callAPI(payload, "POST", ConfigApi.URLS.SPOT_BOOKING.REFUND_SPOT_BOOKING)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(
              res.msg || "Refund processed successfully",
              "Success"
            );
            this.modalService.dismissAll();
            this.resetRefund();
            this.getDetails();
            this.isLoading = false;
          } else {
            this.toastr.error(res.msg, "Error");
            this.isLoading = false;
            this.resetRefund();
          }
        },
        (err) => {
          this.toastr.error(err.error.msg, "Error");
          this.isLoading = false;
          this.resetRefund();
        }
      );
  }

  resetRefund() {
    this.detail = { is_refund_full_amount: null, amountTotal: null };
  }
  getIsDisabled(): boolean {
    if (this.detail.is_refund_full_amount === null) {
      return true;
    }
    if (
      this.detail.is_refund_full_amount === false &&
      (this.detail.amountTotal === null || this.detail.amountTotal <= 0)
    ) {
      return true;
    }

    return false;
  }

  openCancelModal(cancelRequestId: string) {
    this.modalService.open(this.cancelRequestModal, {
      size: "md",
      backdrop: "static",
    });
    this.cancelRequestId = cancelRequestId;
  }
  confirmCancelRequest(bookingId: number | string): void {
    this.isCancelLoading = true;
    this.apiCallingService
      .callAPI(
        {},
        "POST",
        ConfigApi.URLS.SPOT_BOOKING.CANCEL_SPOT_BOOKING + "/" + bookingId
      )
      .subscribe({
        next: (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success(res.msg || "Booking cancelled successfully");
            this.modalService.dismissAll();
            this.getDetails();
            this.isCancelLoading = false;
          } else {
            this.toastr.error(res.msg, "Error");
            this.isCancelLoading = false;
          }
        },
        error: (err) => {
          this.toastr.error(
            err.error?.msg || "Failed to cancel booking",
            "Error"
          );
          this.isCancelLoading = false;
        },
      });
  }
}
